import groupby from 'lodash.groupby';
import get from 'lodash.get';
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { makeSelectQueryStringValue } from 'workspaces/react-router-selectors';
import { selectDocuments } from 'services/documents/selectors';
import { DocumentUuid } from 'services/documents/types';
// @ts-ignore
import { selectSchemaAttribute } from 'services/schemaAttributes/selectors';
// @ts-ignore
import {
    averageInteger,
    averageFloat,
    joinValues,
    averageBoolean
} from 'utils/document-attribute';
import { selectDocumentSetId } from 'services/documentSets/selectors';

const selectDocument = createDeepEqualSelector(
    [selectDocuments, makeSelectQueryStringValue('uuid')],
    (documents, uuid: DocumentUuid) => get(documents, uuid)
);

const selectDocumentAttributes = createDeepEqualSelector(
    [selectDocument, selectDocumentSetId],
    (document, documentSetId) => {
        const documentAttributes = get(document, 'documentAttributes');
        return groupby(documentAttributes, 'schemaAttributeId');
    }
);

const selectAttributeValue = createDeepEqualSelector(
    [selectDocumentAttributes, selectSchemaAttribute],
    (documentAttributes, schemaAttribute: any) => {
        const { id, dataTypeId } = schemaAttribute;
        let value;

        if (!documentAttributes[id]) return value;

        if (dataTypeId === 'INTEGER') {
            const values = documentAttributes[id].map(
                (docAttribute: { integerValue: any }) =>
                    docAttribute.integerValue || 0
            );

            value = averageInteger(values);
        } else if (dataTypeId === 'FLOAT') {
            const values = documentAttributes[id].map(
                (docAttribute: { floatValue: any }) =>
                    docAttribute.floatValue || 0
            );

            value = averageFloat(values);
        } else if (dataTypeId === 'BOOLEAN') {
            const values = documentAttributes[id].map(
                (docAttribute: { booleanValue: any }) =>
                    docAttribute.booleanValue || false
            );

            value = averageBoolean(values);
        } else if (dataTypeId === 'STRING') {
            const values = documentAttributes[id].map(
                (docAttribute: { stringValue: any }) =>
                    docAttribute.stringValue || ''
            );

            value = joinValues(values);
        }

        return value;
    }
);

export const makeSelectAttributeValue = (): typeof selectAttributeValue =>
    selectAttributeValue;
